// import { useEffect, useState } from "react";
import Flag from 'react-world-flags';

import countries from '@/shared/country/countries.json';
import countryNames from '@/shared/country/country_names.json';

const useCountry = () => {
    const getCountry = () => {
        let cArr = [];
        for (const cCode in countryNames) {
            const cName = countryNames[cCode];
            const cObj = { value: cCode, title: cName };
            cArr.push(cObj);
        }
        return cArr;
    };

    const getCountryPhone = () => {
        let cArr = [];
        countries.forEach((e, i) => {
            const cObj = {
                value: e.dial_code,
                title: (
                    <span>
                        <Flag className="c_flag" code={e.code} /> {e.dial_code}
                    </span>
                ),
                code: e.code,
                dial: e.dial_code,
                c_name: e.name,
                flag: <Flag className="c_flag" code={e.code} />,
            };
            cArr.push(cObj);
        });
        return cArr;
    };

    return {
        getCountry,
        getCountryPhone,
    };
};

export default useCountry;

//for selected section loading
